// extracted by mini-css-extract-plugin
export default {"programspage":"programspage_programspage__9yFO2"};